module.exports = __webpack_public_path__ + "static/abell-foundation-logo-black-d0277e49ceb02b32b2bbd657e35142f8.png";